import { render } from "./UpdateModifierOptionGroupForItem.vue?vue&type=template&id=ea61abda&scoped=true"
import script from "./UpdateModifierOptionGroupForItem.vue?vue&type=script&lang=js"
export * from "./UpdateModifierOptionGroupForItem.vue?vue&type=script&lang=js"

import "./UpdateModifierOptionGroupForItem.vue?vue&type=style&index=0&id=ea61abda&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea61abda"]])

export default __exports__